import { apiClient } from "@/lib/apiClient";
import type {
  Condutor,
  CondutorCombo,
  SalvarCondutorRequest,
  Reboque,
  ReboqueCombo,
  SalvarReboqueRequest,
} from "../types";

// ── Condutor ──────────────────────────────────────────────────────────────

export const condutorService = {
  combo: () =>
    apiClient.get<CondutorCombo[]>("/api/condutores").then((r) => r.data),

  listar: (params?: { busca?: string; ativo?: boolean; pagina?: number; tamanhoPagina?: number }) =>
    apiClient
      .get<{ itens: Condutor[]; total: number; pagina: number; tamanhoPagina: number }>(
        "/api/cadastros/condutores",
        { params }
      )
      .then((r) => r.data),

  obterPorId: (id: number) =>
    apiClient.get<Condutor>(`/api/cadastros/condutores/${id}`).then((r) => r.data),

  criar: (req: SalvarCondutorRequest) =>
    apiClient.post<Condutor>("/api/cadastros/condutores", req).then((r) => r.data),

  atualizar: (id: number, req: SalvarCondutorRequest) =>
    apiClient.put(`/api/cadastros/condutores/${id}`, req),

  excluir: (id: number) =>
    apiClient.delete(`/api/cadastros/condutores/${id}`),
};

// ── Reboque ───────────────────────────────────────────────────────────────

export const reboqueService = {
  combo: () =>
    apiClient.get<ReboqueCombo[]>("/api/reboques").then((r) => r.data),

  listar: (params?: { busca?: string; ativo?: boolean; pagina?: number; tamanhoPagina?: number }) =>
    apiClient
      .get<{ itens: Reboque[]; total: number; pagina: number; tamanhoPagina: number }>(
        "/api/cadastros/reboques",
        { params }
      )
      .then((r) => r.data),

  obterPorId: (id: number) =>
    apiClient.get<Reboque>(`/api/cadastros/reboques/${id}`).then((r) => r.data),

  criar: (req: SalvarReboqueRequest) =>
    apiClient.post<Reboque>("/api/cadastros/reboques", req).then((r) => r.data),

  atualizar: (id: number, req: SalvarReboqueRequest) =>
    apiClient.put(`/api/cadastros/reboques/${id}`, req),

  excluir: (id: number) =>
    apiClient.delete(`/api/cadastros/reboques/${id}`),
};
